import { cn } from '@/shared/lib'

import { useCarousel } from './lib/use-carousel'

type Props = {
  className?: string
}

export const SnapDisplay = ({ className }: Props) => {
  const { selectedIndex, scrollSnaps } = useCarousel()

  const currentSnap = selectedIndex + 1
  const totalSnaps = scrollSnaps.length

  if (totalSnaps === 0) return null

  return (
    <div
      className={cn(
        'absolute bottom-[25px] left-1/2 -translate-x-1/2',
        'flex items-center gap-[5px]',
        'typo-caption2 rounded-full bg-black/30 px-2 py-0.5 font-normal text-white',
        className,
      )}
    >
      <span className="flex items-center gap-[5px] after:block after:h-2 after:w-px after:bg-gray-300 after:content-['']">
        {currentSnap}
      </span>
      <span>{totalSnaps}</span>
    </div>
  )
}
